import { Controller } from "../../../Controller";
import {
    InserirDocumentosPorProdutoService,
    ListarDocumentosProdutoService,
    RemoverDocumentosPorProdutoService,
} from "../../../../Services/Geral/Documentos/DocumentoProduto/DocumentoProdutoServices";

export async function ListarDocumentosProdutoController(idProduto: number) {
    return Controller(ListarDocumentosProdutoService(idProduto, false));
}

export async function ListarDocumentosUnidadeController(idProduto: number) {
    return Controller(ListarDocumentosProdutoService(idProduto, true));
}

export async function InserirDocumentosPorProdutoController(
    ID_PRODUTO: number,
    DS_DOCUMENTO_PRODUTO: string,
    DS_NOME_ARQUIVO: string,
    ID_TIPO_DOCUMENTO: number,
    DS_LINK_DRIVE: string,
    FL_DESTAQUE: boolean,
    FL_IMG_IMPLANTACAO: boolean,
    DS_TIPO_DOCUMENTO: string,
    FL_DOCUMENTO_FILHO: boolean,
    requestBody: FormData,
    ID_DOCUMENTO_PRODUTO?: number
) {
    return Controller(
        InserirDocumentosPorProdutoService(
            ID_PRODUTO,
            DS_DOCUMENTO_PRODUTO,
            DS_NOME_ARQUIVO,
            ID_TIPO_DOCUMENTO,
            DS_LINK_DRIVE,
            FL_DESTAQUE,
            FL_IMG_IMPLANTACAO,
            DS_TIPO_DOCUMENTO,
            FL_DOCUMENTO_FILHO,
            requestBody,
            ID_DOCUMENTO_PRODUTO
        )
    );
}

export async function RemoverDocumentosPorProdutoController(
    idDocumentoProduto: number
) {
    return Controller(RemoverDocumentosPorProdutoService(idDocumentoProduto));
}
